import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router';
import { useGetMathSkillStudentsMutation } from '../../../../../features/authentication/classesApiSlice';
import { selectFerpaState } from '../../../../../features/authentication/authSlice';
import { NavLink, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useClassManagementContext } from '../../ClassManagement/utils/classManagementContext';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { SortUtils } from '../../../../../utils/sorting';
import TableSkeleton from '../../../../../components/SkeletonLoader/TableSkeleton';
import { faChartLineUp, faCircleQuestion } from '@fortawesome/pro-solid-svg-icons';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import CustomToast from '../../../../../components/Toast';

const MathSkill =()=>
{
  const[isLoading,setIsLoading] = useState(false);
  const [showRemoved, setShowRemoved] = useState(false);
  const[mathSkillStudents,setMathSkillStudents] = useState([]);
  const [sortColumn, setSortColumn] = useState('lName');
  const [sortDirection, setSortDirection] = useState('asc');
  const[getMathSkillStudents]= useGetMathSkillStudentsMutation();
  const {selectedClassId, selectedCourseId, selectedCustomCourseId, mathSkillCourses } = useClassManagementContext();
  const navigate = useNavigate();
  const ferpaEnabled = useSelector(selectFerpaState);

  useEffect(() => {
    if(selectedClassId > 0 && selectedCourseId != 0)
      if(!mathSkillCourses?.includes(selectedCourseId))
        navigate(`/classes/${selectedClassId}/classSessionsAndReport/sessionsAndReport`);
      else
        getMathSkillStudentsAsync();
  }, [selectedClassId,selectedCourseId]);

  const getMathSkillStudentsAsync = async ()=>{
    setMathSkillStudents([]);
    setIsLoading(true);
    const options ={
      classId:selectedClassId,
      courseId:selectedCourseId === 255 ? selectedCustomCourseId : selectedCourseId
    };
    const response =  await getMathSkillStudents(options);
    if (response.error) {
      if(response.error.data.errors)
        CustomToast(response.error.data.errors.Name, 'error');
      else
        CustomToast(response.error.data.error, 'error');
    }
    else if(response.data){
      setMathSkillStudents(response.data);
    }
    setIsLoading(false);
  };
  
  const renderSortIcons  = (column) =>{
    return (SortUtils.renderSortIcons(sortDirection,sortColumn, column));
  };

  const handleSort = async (column) => {
    let sortedData=[];
    var direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortDirection(direction);
    if(sortDirection === 'asc')
      sortedData = SortUtils.customSort(mathSkillStudents, column, true);
    else
      sortedData = SortUtils.customSort(mathSkillStudents, column, false);
    setMathSkillStudents(sortedData);
  };

  return(
    <div>
      <div className="row message-tab align-items-center mb-3">
        <div className='d-flex justify-content-between mb-4'>
          <div>
              Number Of students <span className="rounded-number mx-1 fw-semibold">{mathSkillStudents.length}</span>
          </div>
          <div>
            <input
              type="checkbox"
              className="form-check-input me-2 cursor-pointer"
              checked={showRemoved}
              id="flexCheckDefault"
              name="allselect"
              onChange={() => setShowRemoved(!showRemoved)}
            />
            <label className="form-check-label">
                Display Removed Students
            </label>
            <OverlayTrigger
              key="label-info"
              placement="top"
              overlay={
                <Tooltip id="parent-tooltip" className="image-info-tooltip">
                  <p>Removed students include those that are Hidden (by teacher), Disabled (by district), or Deactivated (based on account activity or manual deactivation)</p>
                </Tooltip>
              }>
              <FontAwesomeIcon icon={faCircleQuestion} className="circle-question mx-1" />
            </OverlayTrigger>
          </div>
        </div>
        <div className="custom-table table-responsive">
          {!isLoading && mathSkillStudents?.length > 0 &&
              <>
                <table className='table reportTable w-50'>        
                  <thead className="thead-light align-middle">
                    <tr>
                      <th></th>
                      <th scope="col" className={`fw-medium  min-w-150 ${ferpaEnabled && 'cursor-pointer'}`} onClick={() => ferpaEnabled && handleSort('lName')}>
                        <span className='align-items-center d-flex justify-content-between'> <span>Last Name</span> {ferpaEnabled && renderSortIcons('lName')} </span> 
                      </th>
                      <th scope="col" className={`fw-medium  min-w-150 ${ferpaEnabled && 'cursor-pointer'}`}  onClick={() => ferpaEnabled && handleSort('fName')}>
                        <span className='align-items-center d-flex justify-content-between'><span>First Name</span> {ferpaEnabled && renderSortIcons('fName')}</span>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  {!isLoading &&
                  <>
                    {
                      <tbody>
                        {mathSkillStudents?.map((item,index) => (
                          <>
                            {(!item.isDeleted || (showRemoved && item.isDeleted)) && 
                            <tr key={`${item.studentId}-record`}>
                              <td>
                                {item.isDeleted &&
                                  <OverlayTrigger
                                    key="hidden"
                                    placement="top"
                                    overlay={<Tooltip className="custom-tooltip">Hidden
                                    </Tooltip>}>
                                    <div className='hiddenStudent'>
                                      <FontAwesomeIcon icon={faEyeSlash} className='p-1' />
                                    </div>
                                  </OverlayTrigger>
                                }
                              </td>
                              {ferpaEnabled?<td>{item.lName}</td>:<td>Lastname<br></br>hidden</td>}
                              {ferpaEnabled?<td>{item.fName}</td>:<td>Firstname<br></br>hidden</td>}
                              <td>{item.viewReport &&
                                  <NavLink onClick={() => navigate(`${selectedCourseId}/${item.studentId}/skillReport`)}
                                  >
                                    <OverlayTrigger
                                      key={`viewReportToolTip${index}`}
                                      placement="top"
                                      overlay={<Tooltip className="custom-tooltip">View Skills Report</Tooltip>}>
                                      <button className='btn grid-icon-btn info-icon-btn'>
                                        <FontAwesomeIcon icon={faChartLineUp}></FontAwesomeIcon>
                                      </button>
                                    </OverlayTrigger>
                                  </NavLink>}

                              </td>                                                                                           
                            </tr>
                            }
                          </>
                        ))}
                      </tbody>
                    }
                  </>}
                </table>
              </>}
          {isLoading &&
              <>
                <table className='w-50'>
                  <TableSkeleton
                    colCount={3}
                    rowCount={3}/>
                </table>
              </>
          }
        </div>
      </div>
      <Outlet />
    </div>
  );
};

export default MathSkill;